import React from 'react';
import styles from './NumberBadge.module.scss';

const NumberBadge = ({ number, style }) => {
  return (
    <div className={styles.numberBadge} style={style}>
      {number}
    </div>
  );
};

export default NumberBadge;
